import { render, staticRenderFns } from "./BewertungenGesamtUebersicht.vue?vue&type=template&id=6d41c4c6&scoped=true&"
import script from "./BewertungenGesamtUebersicht.vue?vue&type=script&lang=js&"
export * from "./BewertungenGesamtUebersicht.vue?vue&type=script&lang=js&"
import style0 from "./BewertungenGesamtUebersicht.vue?vue&type=style&index=0&id=6d41c4c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41c4c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VProgressCircular,VSelect})
